import { watch } from "vue";

export default function addVModelWatchers({ props, emit, modelProp, dataRef }) {
  modelProp = modelProp || "modelValue";

  let eventName = "update:" + modelProp;

  watch(
    dataRef,
    (val, oldVal) => {
      if (val != oldVal) emit(eventName, val);
    },
    { deep: true }
  );
  watch(
    () => props[modelProp],
    (val) => (dataRef.value = val),
    { deep: true, immediate: true }
  );
}
